import { makeStyles, createStyles } from '@material-ui/styles'

const SlideshowItemStyles = makeStyles((theme) =>
  createStyles({
    container: {
      height: '100%',
      display: 'flex',
      flexDirection: 'column',
      justifyContent: 'center',
      alignItems: 'center',
    },
    header: {
      width: '100%',
      display: 'flex',
      padding: '2vh',
      alignSelf: 'flex-start',
      borderBottom: `1px solid ${theme.color.lightGray}`,
      backgroundColor: theme.palette.paper.primary,
    },
    headerText: {
      fontWeight: theme.typography.fontWeightBold,
      color: theme.palette.components.linkList,
    },
    wrapper: {
      width: '100%',
      height: '100%',
      display: 'flex',
      justifyContent: 'center',
      backgroundColor: theme.palette.paper.secondary,
      boxSizing: 'border-box',
    },

    root: {
      width: '100%',
      maxWidth: 900,
      backgroundColor: 'transparent',
      borderRadius: 12,
      overflow: 'hidden',
      [theme.breakpoints.down('sm')]: {
        padding: '10px',
      },
      display: 'flex',
      flexDirection: 'column',
      alignItems: 'center',
      paddingBottom: 16,
    },

    media: {
      width: '100%',
      backgroundSize: 'cover',
      backgroundPosition: 'center',
      backgroundColor: theme.color.lightGray,
      borderRadius: 8,
      marginTop: 15,
      aspectRatio: '16/9',
    },

    content: {
      width: '100%',
      padding: '20px 0px 10px 0px',
      textAlign: 'left',
    },

    contentRight: {
      textAlign: 'right',
    },

    title: {
      marginBottom: 12,
      fontWeight: theme.typography.fontWeightBold,
      color: theme.palette.components.linkList,
    },

    description: {
      color: theme.palette.components.linkList,
    },

    // --- DOT INDICATORS (used in SlideshowScreen) ---
    indicator: {
      width: 15,
      height: 15,
      borderRadius: '50%',
      backgroundColor:
        theme.palette.type === 'dark'
          ? theme.palette.base.gray
          : theme.palette.base.lightGray,
      margin: '0 6px',
      cursor: 'pointer',
      display: 'inline-block',
      transition: 'all 0.3s ease',
    },

    indicatorActive: {
      width: 33,
      height: 15,
      borderRadius: 20,
      backgroundColor: theme.palette.base.red,
    },

    indicatorsContainer: {
      display: 'flex',
      justifyContent: 'center',
      alignItems: 'center',
    },

    // --- BUTTONS ---
    navButton: {
      border: `1px solid ${theme.palette.base.red}`,
      color: theme.palette.base.black,
      borderRadius: 8,
      padding: '6px 16px',
      textTransform: 'none',
      fontWeight: 700,
      backgroundColor: theme.color.rutgersLightPink,
      '&:hover': {
        backgroundColor: theme.color.rutgersLightPink,
      },
    },
    navButtonClose: {
      backgroundColor: theme.palette.base.red,
      color: theme.palette.base.white,
      fontWeight: 700,
      '&:hover': {
        backgroundColor: theme.color.darkerRed,
      },
    },

    footer: {
      display: 'flex',
      width: '100%',
      backgroundColor: theme.palette.paper.primary,
      borderTop: `1px solid ${theme.color.lightGray}`,
      position: 'absolute',
      bottom: 0,
      justifyContent: 'center',
    },
    controlsWrapper: {
      width: '100%',
      maxWidth: 900,
      display: 'flex',
      justifyContent: 'space-between',
      alignItems: 'center',
      marginTop: 5,
      padding: theme.spacing(1),
    },
  }),
)

export default SlideshowItemStyles
